import React, { FC } from 'react';
import { Table as AntTable, theme } from 'antd';
import { TableProps } from 'antd/lib';

type Props = {
  style?: React.CSSProperties;
  data?: any[];
  emptyText?: string;

  checkbox?: boolean;
  onCheck?: any;

  columns: any[];
  expandable?: TableProps['expandable'];
  rowKey?: string | ((record: any) => string);
} & TableProps;

export const Table: FC<Props> = (properties) => {
  const appTheme = theme.useToken().token;
  return (
    <>
      <AntTable
        pagination={
          properties.pagination === false
            ? false
            : {
                showTotal: (total) => `Total ${total} items`,
                showSizeChanger: true,
                defaultCurrent: 1,
                style: { marginLeft: '12px' },
                position: ['bottomLeft'],
                ...(typeof properties.pagination === 'object' ? properties.pagination : {}),
              }
        }
        locale={{ emptyText: properties.emptyText }}
        rowSelection={
          (properties.checkbox && {
            type: 'checkbox',
            onSelect: properties.onCheck,
          }) ||
          undefined
        }
        style={{ ...properties.style, border: '1px solid rgba( 0, 0, 0, 0.05 )' }}
        columns={properties.columns}
        dataSource={properties.data}
        scroll={{ x: 'max-content' }}
        onRow={properties.onRow}
        expandable={properties.expandable}
        rowKey={properties.rowKey || 'key'}
      />
    </>
  );
};

export default Table;
